//This file is automatically rebuilt by the Cesium build process.
export default "const float czm_passClassification = 7.0;\n\
";
